import * as Sentry from '@sentry/nextjs';

function fallbackCopyTextToClipboard(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
}

function copyTextToClipboard(text: string): Promise<void> {
    return new Promise((resolve, reject): void => {
        try {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(resolve, reject);
            resolve();
        } catch (err) {
            Sentry.captureException(err);
            throw new Error(err);
        }
    });
}

export default copyTextToClipboard;
